import { __rest } from '../../_virtual/_tslib.js';
import { GridPresentation, GridRowPresentation, GridColumnWrapper } from '@lsg/shared';
import { createElement } from 'react';

/** @deprecated union type should be used now  (Date: 08.11.2021) */

var HorizontalAlign;

(function (HorizontalAlign) {
  HorizontalAlign["LEFT"] = "left";
  HorizontalAlign["CENTER"] = "center";
  HorizontalAlign["RIGHT"] = "right";
})(HorizontalAlign || (HorizontalAlign = {}));
/** @deprecated union type should be used now (Date: 08.11.2021) */


var VerticalAlign;

(function (VerticalAlign) {
  VerticalAlign["TOP"] = "top";
  VerticalAlign["MIDDLE"] = "middle";
  VerticalAlign["BOTTOM"] = "bottom";
})(VerticalAlign || (VerticalAlign = {}));
/** @deprecated , union type should be used now (Date: 08.11.2021) */


var Spacing;

(function (Spacing) {
  Spacing["SECTION"] = "section";
  Spacing["DOUBLE_SUBSECTION"] = "doublesubsection";
  Spacing["HALF_SECTION"] = "doublesubsection";
  Spacing["CONTAINER"] = "subsection";
  Spacing["SUBSECTION"] = "subsection";
})(Spacing || (Spacing = {}));

var Grid = function Grid(_a) {
  var verticalSpacing = _a.verticalSpacing,
      spacing = _a.spacing,
      props = __rest(_a, ["verticalSpacing", "spacing"]);

  return /*#__PURE__*/createElement(GridPresentation, Object.assign({}, props, {
    spacing: spacing || verticalSpacing
  }));
};

Grid.Row = function (_a) {
  var verticalAlign = _a.verticalAlign,
      props = __rest(_a, ["verticalAlign"]);

  return /*#__PURE__*/createElement(GridRowPresentation, Object.assign({}, props, {
    verticalAlignment: verticalAlign
  }));
};

Grid.Column = function (_a) {
  var horizontalAlign = _a.horizontalAlign,
      horizontalAlignXs = _a.horizontalAlignXs,
      horizontalAlignSm = _a.horizontalAlignSm,
      horizontalAlignMd = _a.horizontalAlignMd,
      props = __rest(_a, ["horizontalAlign", "horizontalAlignXs", "horizontalAlignSm", "horizontalAlignMd"]);

  return /*#__PURE__*/createElement(GridColumnWrapper, Object.assign({}, props, {
    horizontalAlignment: horizontalAlign,
    horizontalAlignmentXs: horizontalAlignXs,
    horizontalAlignmentSm: horizontalAlignSm,
    horizontalAlignmentMd: horizontalAlignMd
  }));
};

Grid.HorizontalAlign = HorizontalAlign;
Grid.VerticalAlign = VerticalAlign;
Grid.Spacing = Spacing;
Grid.displayName = "Grid";

export { Grid, HorizontalAlign, Spacing, VerticalAlign };
